import { render, staticRenderFns } from "./ReciprocityDurationModal.vue?vue&type=template&id=3389d78a&scoped=true&"
import script from "./ReciprocityDurationModal.vue?vue&type=script&lang=js&"
export * from "./ReciprocityDurationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389d78a",
  null
  
)

export default component.exports